import FullScreenLayout from './FullScreenLayout';

export default FullScreenLayout;
